import { Injectable, signal } from "@angular/core";

export type AppTheme = "light" | "dark";

@Injectable({ providedIn: "root" })
export class ThemeService {
  private readonly storageKey = "streamquest_theme";
  private readonly themeSignal = signal<AppTheme>("dark");
  readonly theme = this.themeSignal.asReadonly();

  constructor() {
    const stored = localStorage.getItem(this.storageKey) as AppTheme | null;
    const preferred = stored || "dark";
    this.applyTheme(preferred);
  }

  toggleTheme() {
    this.applyTheme(this.themeSignal() === "dark" ? "light" : "dark");
  }

  private applyTheme(theme: AppTheme) {
    this.themeSignal.set(theme);
    localStorage.setItem(this.storageKey, theme);

    const root = document.documentElement;
    root.classList.remove("theme-light", "theme-dark");
    root.classList.add(theme === "dark" ? "theme-dark" : "theme-light");
  }
}
